/* eslint-disable complexity */
import { AbsatzVorgabe } from '@/domain/controlling/entities';
import { TagebuchAnzeige } from '@/domain/controlling/entities/tagebuchAnzeige';
import { maskitoParseNumber } from '@maskito/kit';
import { z } from 'zod';

export const updateTagebuchEinstellungenSchema = z
  .object({
    umsatzplanungAnzeige: z.enum(Object.values(TagebuchAnzeige)),
    zielProduktivitaetUmsatz: z.string().optional(),
    zielProduktivitaetAbsatz: z
      .object({
        value: z.string(),
        unit: z.enum(AbsatzVorgabe),
      })
      .optional(),
  })
  .superRefine((data, ctx) => {
    const umsatzInValid =
      !data.zielProduktivitaetUmsatz ||
      isNaN(
        maskitoParseNumber(data.zielProduktivitaetUmsatz ?? '', {
          decimalSeparator: ',',
        }),
      );

    const absatzInValid =
      !data.zielProduktivitaetAbsatz?.value ||
      isNaN(
        maskitoParseNumber(data.zielProduktivitaetAbsatz.value ?? '', {
          decimalSeparator: ',',
        }),
      );
    switch (data.umsatzplanungAnzeige) {
      case 'UMSATZ_PRODUKTIVITAET':
        if (umsatzInValid) {
          ctx.addIssue({
            code: 'custom',
            message: 'Bitte gib einen gültigen Wert ein',
            path: ['zielProduktivitaetUmsatz'],
          });
        }

        break;

      case 'ABSATZ_PRODUKTIVITAET':
        if (absatzInValid) {
          ctx.addIssue({
            code: 'custom',
            message: 'Bitte gib einen gültigen Wert ein',
            path: ['zielProduktivitaetAbsatz'],
          });
        }
        break;

      case 'UMSATZ_ABSATZ_PRODUKTIVITAET':
        if (absatzInValid) {
          ctx.addIssue({
            code: 'custom',
            message: 'Bitte gib einen gültigen Wert ein',
            path: ['zielProduktivitaetAbsatz'],
          });
        }
        if (umsatzInValid) {
          ctx.addIssue({
            code: 'custom',
            message: 'Bitte gib einen gültigen Wert ein',
            path: ['zielProduktivitaetUmsatz'],
          });
        }
        break;
      default:
        break;
    }
  });
